// lazyload
import LazyLoad from "vanilla-lazyload";

import mainNav from "../modules/mainNav.js";

import { wpcf7Validation } from "../modules/wpcf7Utilities.js";

import countUp from "../modules/countUp.js";

import interactiveMap from "../modules/interactiveMap.js";

// woocommerce interactive notices
import wooNotices from "../modules/wooNotices";

import googleTranslateLazyFix from "../modules/googleTranslateLazyFix.js";

import variationGalleryImage from "../modules/wooVariationGallery";

window.addEventListener('load', () => {
	const lazyLoadInstance = new LazyLoad({
		elements_selector: ".lazy"
	});

	new mainNav('.main-menu', '.main-nav', '.main-menu__toggle');

	// reveal init
	require('../modules/reveal');

	// fslightbox gallery
	require('fslightbox');

	require('../modules/lightboxWPGallery');

	wpcf7Validation();
	
	countUp(".js-countup-trigger", ".js-countup-target", 2, 0.5);

	wooNotices();

	// sec3Parallax('.gsap-parallax');
	// parallaxReveal('.js-gsap-parralax-reveal');

	interactiveMap();

	googleTranslateLazyFix();

	variationGalleryImage();
});
